class Opal_Elementor_General {
    static instance;

    static getInstance() {
        if (!Opal_Elementor_General.instance) {
            Opal_Elementor_General.instance = new Opal_Elementor_General();
        }
        return Opal_Elementor_General.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-account.default', ($scope) => {
                
                $scope.$toggle = $scope.find('.opal-account-popup-btn');
                if( $scope.$toggle ) {
                    var effect =  $scope.$toggle.data('effect') 

                    $scope.$toggle.magnificPopup({
                        type        : 'inline',
                        removalDelay: 500,
                        overflowY   : 'hidden',
                        callbacks   : {
                            beforeOpen: function () {  
                                this.st.mainClass = effect;
                            },
                            close: function () {
                                 $scope.$toggle.removeClass('opalelementor-active');
                            }
                        },
                        midClick    : true
                    });

                }
        });

        /// /*
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-masonry-posts.default', ( $scope ) => {
              // product wiget
            var $container = $( '.elementor-masonry-style', $scope );

          //  console.log( $container.html() );
          //   $container.find('first').removeClass('first');
            // initialize Masonry after all images have loaded
            $container.find('.elementor-items-container').imagesLoaded(function() {  
                $container.find('.elementor-items-container').isotope({
                  
                    isOriginLeft: ! $('body').hasClass('rtl'),
                    itemSelector: '.column-item'
                });
            });
            $('.isotype-filter a', $container).click( function(){

                $container.find('.elementor-items-container').isotope({
                    filter:'.'+$(this).data( 'filter' )  
                });
                return false; 
            } );

        } );
        /////

        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-offcanvas-sb.default', ( $scope ) => {

            var $wap = $("#page");

            if( !$wap.hasClass('c-offcanvas-content-wrap') ){
                $wap.addClass('c-offcanvas-content-wrap');
            }
            var $button = $( $scope ).find( '.c-elementor-button-link' ); 
 
            if( $button ){
                $( '#'+$button.data('container') ).offcanvas( {
                    modifiers: $button.data('appear'),
                    triggerButton: "#"+$button.attr('id')
                } );  

              //  alert(  $( '#'+$button.data('container') ).find('.opalelementor-nav-menu').html() );

                $( '#'+$button.data('container') ).find('.opalelementor-nav-menu').smartmenus({
                      subMenusSubOffsetX: 1,
                        subMenusSubOffsetY: -8,
                    collapsibleBehavior: 'accordion'
                }); 
            }
        } );
    }
}


Opal_Elementor_General.getInstance();

